<template>
  <div
    class="mm-skeleton"
    :style="{ width, background }"
  >
    <slot v-if="$slots.default" />
    <div
      v-for="item of row"
      v-show="row"
      v-else
      :key="'skeleton-row' + item"
      :style="{ background }"
    >{{ row }}</div>
  </div>
</template>

<script>
export default { name: 'MmSkeleton' }
</script>
<script setup>
defineProps({
  width: {
    type: String,
    required: false,
    default: undefined,
  },
  background: {
    type: String,
    required: false,
    default: 'rgb(239,239,239)',
  },
  // 占位，几行文字
  row: {
    type: Number,
    required: false,
    default: 1,
  },
})
</script>

<style lang="scss" scoped>
.mm-skeleton{
  position: relative;
  &,
  div{
    color: transparent !important;
  }
  &:after{
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0) 80%) no-repeat;
    animation: backpos 2s ease-in-out 0s infinite;
  }
  div{
    height: 100%;
  }
}
@keyframes backpos {
  0% {
    background-position-x: -500px;
  }
  to {
    background-position-x: calc(500px + 100%);
  }
}

</style>
